// Sign In Form Validation
function validateLoginPhone() {
  let isValid = true;
  const signInPhone = document.querySelector("#signInPhone").value;
  
  clearError("#signInPhoneError");
  if(!signInPhone) {
    displayError('#signInPhoneError', 'Phone Number is Required');
    isValid = false;
  }else if(!/^[6789]\d{9}$/.test(signInPhone)) {
    displayError('#signInPhoneError', 'Enter a Valid 10 Digit Phone Number');
    isValid = false;
  }

  return isValid;
}

function validateLoginOTP() {
  let isValid = true;
  const signInOTP = document.querySelector("#signInOTP").value;
  
  clearError("#signInOTPError");
  if(!signInOTP) {
    displayError('#signInOTPError', 'OTP is Required');
    isValid = false;
  }else if(!/^\d{6}$/.test(signInOTP)) {
    displayError('#signInOTPError', 'Invalid OTP');
    isValid = false;
  }

  return isValid;
}

// Sign Up Form Validation
async function validateSignupForm() {
  let isValid = true;

  const firstName = document.querySelector('#customerFirstName').value.trim();
  const lastName = document.querySelector('#customerLastName').value.trim();
  const signUpEmail = document.querySelector('#signUpEmail').value.trim();
  const signUpPhone = document.querySelector('#signUpPhone').value.trim();
  const signUpPincode = document.querySelector('#signUpPincode').value.trim();
  //const signUpAddress = document.querySelector('#signUpAddress').value.trim();
  //const checkBox1 = document.querySelector('#checkbox1').checked;
  const checkBox2 = document.querySelector('#checkbox2').checked;
  const checkBox3 = document.querySelector('#checkbox3').checked;

  // Clear Previous Error Messages
  clearError('#signUpFirstNameError');
  clearError('#signUpLastNameError');
  clearError('#signUpEmailError');
  clearError('#signUpPhoneError');
  clearError('#signUpPincodeError');
  //clearError('#signUpAddressError');
  //clearError('#signUpCheckbox1Error');
  clearError('#signUpCheckbox2Error');
  clearError('#signUpCheckbox3Error');

  if(!firstName) {
    displayError('#signUpFirstNameError', 'First Name is Required');
    isValid = false;
  }

  if(!lastName) {
    displayError('#signUpLastNameError', 'Last Name is Required');
    isValid = false;
  }

  if(!signUpEmail) {
    displayError('#signUpEmailError', 'Email is Required');
    isValid = false;
  }else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signUpEmail)) {
    displayError('#signUpEmailError', 'Enter a Valid Email Address');
    isValid = false;
  }

  if(!signUpPhone) {
    displayError('#signUpPhoneError', 'Mobile Number is Required');
    isValid = false;
  }else if(!/^[6789]\d{9}$/.test(signUpPhone)) {
    displayError('#signUpPhoneError', 'Enter a Valid 10 Digit Phone Number');
    isValid = false;
  }

  if(!signUpPincode) {
    displayError('#signUpPincodeError', 'Pincode is Required');
    isValid = false;
  }else if(!/^\d{6}$/.test(signUpPincode)) {
    displayError('#signUpPincodeError', 'Enter a Valid Pincode');
    isValid = false;
  }else {
    const pincodeStatus = await fetchPincodeStatus(signUpPincode);
    if(pincodeStatus === "active") {
      isValid = true;
    }else if(pincodeStatus === "in-active") {
      displayError('#signUpPincodeError', 'Below Pincode is Not Serviceable');
      isValid = false;
    }else {
      displayError('#signUpPincodeError', 'Enter a Valid Pincode');
      isValid = false;     
    }
  }

  // if(!signUpAddress) {
  //   displayError('#signUpAddressError', 'Address is Required');
  //   isValid = false;
  // }else if(signUpAddress.length < 14) {
  //   displayError('#signUpAddressError', 'Address must be at least 14 characters long');
  //   isValid = false;
  // }

  // if(!checkBox1) {
  //   displayError('#signUpCheckbox1Error', 'You must agree to the Privacy Policy, Terms of Use and Shipping Policy');
  //   isValid = false;
  // }

  if(!checkBox2) {
    displayError('#signUpCheckbox2Error', 'You must agree to all Policies');
    isValid = false;
  }

  // if(!checkBox3) {
  //   displayError('#signUpCheckbox3Error', 'You must agree to receive all Messages');
  //   isValid = false;
  // }

  return isValid;
}

// Display Error Message
function displayError(fieldId, message) {
  const errorElement = document.querySelector(fieldId);
  
  if(errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = 'block';
  }
}

// Clear Error Message
function clearError(fieldId) {
  const errorElement = document.querySelector(fieldId);
  
  if(errorElement) {
    errorElement.textContent = '';
    errorElement.style.display = 'none';
  }
}

// Registration Active & In-active Pincode
async function fetchPincodeStatus(pincode) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const reqBody = {
    "pincode": pincode
  }

  const encrypted = CryptoUtil.encryptRequest("POST", reqBody);

  const raw = JSON.stringify({
    iv: encrypted.iv,
    payload: encrypted.payload
  });

  myHeaders.append("seal", encrypted.seal);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  try {
    const response = await fetch(`${window.Base_Url.Base_Url}/api/auth/V3/checkregistrationstatusV3`, requestOptions);
    const data = await response.json();
    const result = CryptoUtil.decryptResponse(data);
    
    if(result.Status === 'Active') {
      return "active";
    }else if(result.Status === "In-Active" || result.Status === "In-active") {
      return "in-active";
    }else {
      return null;
    }
  }catch(error) {
    console.error("Error Fetching Pincode Status:", error);
    return null;
  }
}

// Auto Fill District (ENS API)
document.addEventListener('DOMContentLoaded', function() {
  const savedPincode = localStorage.getItem('pincodevalue');
  
  if(savedPincode && savedPincode.length === 6) {
    fetchDistrictByPincode(savedPincode);
  }

  document.getElementById('signUpPincode').addEventListener('input', function() {
    const pincodeInput = this.value.trim();

    if(pincodeInput.length === 6) {
      fetchDistrictByPincode(pincodeInput);
    }else {
      document.getElementById('signUpDistrict').value = '';
    }
  });

  function fetchDistrictByPincode(pincode) {
      const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");        
          const payloadPincode = {
            pincode: pincode
          };
          
          const encrypted = CryptoUtil.encryptRequest("GET", payloadPincode);
          
          myHeaders.append("seal", encrypted.seal);
          
          
          fetch(`${window.Base_Url.Base_Url}/v2/V3/pincodeV3?iv=${encodeURIComponent(encrypted.iv)}&payload=${encodeURIComponent(encrypted.payload)}`, {
            method: 'GET',
            headers: myHeaders
          })
          .then(response => response.json())
          .then(result => {
            const data = CryptoUtil.decryptResponse(result);
            //console.log("data11" , data)
            if (data.success && data.data.length > 0) {
              const pincodeLocation = data.data[0];
              document.getElementById('signUpDistrict').value = pincodeLocation.District;
            } else {
              document.getElementById('signUpDistrict').value = '';
            }
          })
          .catch(error => {
            console.error('Error Fetching Data:', error);
            document.getElementById('signUpDistrict').value = '';
          });
  }
});

// Auto Fill State & City
document.getElementById('signUpPincode').addEventListener('input', function() {
  const pincodeInput = this.value.trim();
  
  if(pincodeInput.length === 6) {
   const myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  const pincode = {
                    pincode:pincodeInput
                  }                  
                  const Key = window.generateRandomString(32);
                  const payload = window.Encrypt(pincode, Key);
                  const sealValue = window.md5(`${payload}${Key}`);
                  myHeaders.append("sealvalue", sealValue);
                  myHeaders.append("key", Key);
                  fetch(`${window.Base_Url.Base_Url}/google-map/geocode?data=${encodeURIComponent(payload)}`, {
                    method: 'GET',
                    headers: myHeaders
                  })
                    .then(response => response.text()) // Assuming response is plain text
                    .then(result => {
                      const plainData = result.split("|")[0];
                      const EncKey = result.split("|")[1].split("%%")[0];
                      const data = window.Decrypt(plainData, EncKey);                             
                      if (data.results && data.results.length > 0) {
                        const addressComponents = data.results[0].address_components;                 
                        const cityComponent = addressComponents.find(component => component.types.includes("locality"));
                        const newcity = cityComponent ? cityComponent.long_name : "";                
                        const stateComponent = addressComponents.find(component => component.types.includes("administrative_area_level_1"));
                        const newstate = stateComponent ? stateComponent.long_name : "";                  
                        localStorage.setItem("PincodeCity", newcity); // Store City in localStorage
                        document.getElementById('signUpCity').value = newcity;
                        document.getElementById('signUpState').value = newstate;
                      }
                    })
                    .catch(error => {
                      console.error("Fetch error:", error);
                    });
  }else {
    document.getElementById('signUpCity').value = '';
    document.getElementById('signUpState').value = '';
  }
});